import React, { useState, useEffect } from 'react';
import ViewEtkPostModelJson from './ViewEtkPostModelJson';
import ViewEtkKitJson from './ViewEtkKitJson';
import Button from '@mui/material/Button';
import { NotificationManager } from "react-notifications";
import { ApproveEtkRegistrationQueueOrder } from '../../../services/EtkRegistrationService';

const ViewQueueItem = ({ queueItem,onApprove }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedKitItem, setSelectedKitItem] = useState(null);

  useEffect(() => {
    handleViewClick();
  }, []);

  const handleViewClick = () => {
    const modelJson = queueItem.modelJson;
    const preModelJson = queueItem.preModelJson;
    setSelectedKitItem(queueItem.kitJson);
    if (modelJson) {
      setSelectedItem(modelJson);
    } else if (preModelJson) {
      setSelectedItem(preModelJson);
    }
  };

  const approveQueueItem = async () => {
    try {
      let response = await ApproveEtkRegistrationQueueOrder(queueItem.id);
      if(response.results){
        NotificationManager.success('ETK Order Approved.');
        onApprove()
      }
      else{
        NotificationManager.error('Something went wrong.');
      }
    } catch (err) {
      NotificationManager.error('Something went wrong.');
    } 
  };

  const handleApproveClick = () => {
    console.log('Approve clicked for id:', queueItem.id);
    approveQueueItem()
  };

  return (
    <div style={{ position: 'relative' }}>
      {queueItem.isKitApproved !== null && queueItem.isKitApproved === true ? (
        <>
        <span style={{ color: 'green' }}>Approved</span>
        
        <div>
        <Button
          onClick={handleApproveClick}
          variant="contained"
          style={{ backgroundColor: 'red', color: 'white', marginBottom:'20px', marginTop:"10px" }}
        >
          Revert Approval
        </Button>
        </div>
        </>
        
        
      ) : (
        <Button
          onClick={handleApproveClick}
          variant="contained"
          disabled={queueItem.isKitApproved}
          style={{ backgroundColor: 'green', color: 'white', marginBottom:'20px' }}
        >
          Approve
        </Button>
      )}
      {selectedItem !== null && <ViewEtkPostModelJson etkPostModel={selectedItem} orderNumber={queueItem.orderNumber} />}
      {selectedKitItem !== null && <ViewEtkKitJson etkKit={selectedKitItem} />}
    </div>
  );
};

export default ViewQueueItem;
